module.exports = __webpack_public_path__ + "static/media/ICBT 3a.7f22f69d.jpg";